module.exports = __webpack_public_path__ + "media/images/gallery/constellations/capricornus/cap_gc-b527cf2e0b72a48a63d74dfba62bbddd.gif";